import DownloadFile from '@Components/DownloadFile';
import { useGetFinancialFromOneReport } from '@Domains/FinancialStatements';
import { formatToThaiDate, getBuddhistYear } from '@Utils/datetime';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useProfile } from 'src/Constant/UserProfileContext/UserProfileProvider';
import { ERROR_MESSAGES, getErrorMessageRes, getErrorMessageTh } from './utils';

const FinancialStatementsOneReportTh = () => {
  const { user } = useProfile();
  const { progressData } = useProgressBar();

  const companyId = user?.I_COMPANY_ID?.toString() || '';

  const startOperatingYear =
    progressData?.report?.startOperatingYear ?? getBuddhistYear();

  const [{ data: oneReportData, loading, error }] =
    useGetFinancialFromOneReport(companyId, startOperatingYear, 'th');

  const handleDownloadFileTh = () => {
    if (oneReportData?.url) {
      window.open(oneReportData.url, '_blank');
    }
  };
  const errorMessage = oneReportData
    ? getErrorMessageTh(oneReportData)
    : getErrorMessageRes(error);

  return (
    <DownloadFile
      label={
        'แบบแสดงรายการข้อมูลประจำปี / รายงานประจำปี แบบ 56-1 One Report (ไทย)'
      }
      onDownload={handleDownloadFileTh}
      loading={loading}
      url={oneReportData?.url}
      severity={
        errorMessage === ERROR_MESSAGES.NO_URL_TH || error ? 'error' : 'info'
      }
      publishDate={
        oneReportData?.receiveDate
          ? formatToThaiDate(oneReportData.receiveDate)
          : undefined
      }
      disabled={!oneReportData?.url}
      alertMessage={errorMessage}
    />
  );
};

export default FinancialStatementsOneReportTh;
